import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import {computed} from "vue";
import {ref} from "vue";

interface Props {
  isToolbar?: boolean
  withBadge?: boolean
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'SogCardActions',
  props: {
    isToolbar: { type: Boolean, default: false },
    withBadge: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props


const _style = computed(() => {
  const result = ref("")
  //const result = ref("background-color: red;")
  if (props.isToolbar) {
    result.value += "padding-top: 0; padding-bottom:12px;"
  }
  return result.value
  //return "" + (props.isToolbar ? "padding-top: 0; padding-bottom:0;background-color: red; " : "");
})

const _styleRow = computed(() => {
  const result = ref("justify-content: flex-start;padding-bottom: 3px;padding-left: 3px;")
  if (props.withBadge) {
    result.value += "height:44px;"
  }
  return result.value;
  //return "" + (props.isToolbar ? "padding-top: 0; padding-bottom:0;background-color: red; " : "");
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "e-card-actions",
    style: _normalizeStyle(_style.value )
  }, [
    _createVNode(SogFlexRow, {
      style: _normalizeStyle(_styleRow.value)
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["style"])
  ], 4))
}
}

})